import type { Agent } from 'src/api/squad/types.gen'

export type AgentGlyphAgent = Pick<Agent, 'avatar_url' | 'settings'>

type AgentSnapshot = AgentGlyphAgent & { id: string }

const STORAGE_KEY = 'skalx.account.squad-agent'

const iconSettingOf = (settings: unknown) =>
  typeof settings === 'object' && settings !== null && 'icon' in settings
    ? { icon: settings.icon }
    : undefined

export const rememberAgent = (agent: Agent) => {
  const snapshot: AgentSnapshot = {
    id: agent.id,
    avatar_url: agent.avatar_url,
    settings: iconSettingOf(agent.settings)
  }

  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot))
  } catch {
    return
  }
}

export const recallAgent = (
  agentId: string | null
): AgentGlyphAgent | undefined => {
  try {
    const snapshot = JSON.parse(
      localStorage.getItem(STORAGE_KEY) ?? 'null'
    ) as AgentSnapshot | null

    return snapshot?.id === agentId ? snapshot : undefined
  } catch {
    return undefined
  }
}
